import '.ey{font-size:1.125rem;}.ssr-plugin'
import '.eg{line-height:1.75rem;}.ssr-plugin'
import '.i7{text-decoration:none;}.ssr-plugin'
import '.fw{color:var(--primary-red);}.ssr-plugin'
import { pages } from '@app/util/links'
import { useTranslations } from '@i18n/useLanguage'
import { styled } from 'inlines'

export const TermsAndConditions = () => {
  const translations = useTranslations().app.auth
  return (
    <p className="ey eg"
    >
      {translations.privacySubtitle}{' '}
      <a className="i7 fw"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.privacyStatementLink}
      </a>{' '}
      {translations.privacySubtitleAnd}{' '}
      <a className="i7 fw"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.termsAndConditionsLink}
      </a>
    </p>
  )
}
